export default {
      id: "ic_bets_changes_stack_circleV2-usage",
      viewBox: "0 0 20 20",
      url: "/" + "images/icons.3.109.2.svg#ic_bets_changes_stack_circleV2-usage",
      toString: function () {
        return this.url;
      }
    }